import { getHostname } from '@/api/window';

const MissingManifest = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: '20px',
      }}
    >
      <div>
        <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Not Found</h1>
        <p>
          Hostname (<strong>{getHostname()}</strong>) has not been configured
          yet.
        </p>
      </div>
    </div>
  );
};

export default MissingManifest;
